import { PylotFrontendConfig } from 'config'

export const formatPrice = (
    input: string | number = 0,
    config?: PylotFrontendConfig
): string => {
    let price = typeof input === 'string' ? parseFloat(input) : input
    if (Number.isNaN(price)) {
        price = 0
    }
    return price.toFixed(config?.seo.product.price?.precision ?? 2)
}
